import routes from 'routes';

export const getPrintDisplay = location => {
    if(location.pathname === routes.account.reports) {
        return 'none';
    }
    return undefined;
};
